module.exports = __webpack_public_path__ + "assets/images/cockpit/inactive/btn_contact-inactive_ru.png";